import { render, staticRenderFns } from "./SegurancaContaForm.vue?vue&type=template&id=772e4bef"
import script from "./SegurancaContaForm.vue?vue&type=script&lang=js"
export * from "./SegurancaContaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports